import { useState } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useUpdateFirmSetting = () => {
  const [error, setError] = useState(null);

  const updateFirmSetting = async (userId, updatedSettings) => {
    const { _id, ...settingsWithoutId } = updatedSettings;

    try {
      const payload = {
        user_id: userId,
        ...settingsWithoutId,
      };

      const response = await api_without_cancellation.post(
        "/api/firmsetting-page/update-user-permissions/",
        payload
      );

      return response;
    } catch (err) {
      setError(err.message || "Unknown error");
      console.error("API error caught in catch:", err);
      return null;
    }
  };

  return { updateFirmSetting, error };
};

export default useUpdateFirmSetting;
